import { VersioningStatusEnum } from '@/enums/VersioningStatus';
import CoursePath from '@/models/CoursePath';

type canDeleteCoursePathProps = {
  coursePath: CoursePath;
};
export function canDeleteCoursePath({
  coursePath,
}: canDeleteCoursePathProps): boolean {
  return (
    coursePath.status === VersioningStatusEnum.EDITING ||
    (coursePath.status === VersioningStatusEnum.VERSIONING &&
      coursePath.version > 1)
  );
}
